export const NODE_ENV = process.env.NODE_ENV;
export const RUNTIME_ENV = process.env.VUE_APP_RUNTIME_ENV;
export const APP_PREFIX = process.env.VUE_APP_PREFIX;
export const APP_SECURITY = process.env.VUE_APP_SECURITY;
